import DrawerHelpPanel from '@/ui/Layout/Header/DrawerHelpPanel';
import useGet from '@/utils/hooks/api/typescript/useGet';
import useHubTranslation from '@/utils/i18n/useHubTranslation';
import HelpSharp from '@mui/icons-material/HelpSharp';
import { IconButton } from '@mui/material';
import { useState } from 'react';

export default function HelpButton() {
  const { translateHubUi } = useHubTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const { data: helpPanels, isLoading: helpPanelsLoading } = useGet(
    '/helpPanels',
    {
      fireOnMount: true,
    }
  );

  return (
    <>
      <IconButton
        disableRipple
        onClick={() => setDrawerOpen(true)}
        color='primary'
        aria-label={translateHubUi('nav.header.helpButton.ariaLabel', 'help')}
      >
        <HelpSharp />
      </IconButton>
      <DrawerHelpPanel
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        helpPanels={helpPanels}
        helpPanelsLoading={helpPanelsLoading}
      />
    </>
  );
}
